// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDmLpXp3V9QXxp4EXb2eUlIiCgJPXiUMK4",
  authDomain: "betabook-683f0.firebaseapp.com",
  projectId: "betabook-683f0",
  storageBucket: "betabook-683f0.firebasestorage.app",
  messagingSenderId: "512944672240",
  appId: "1:512944672240:web:eb7a96afae7daacfdfe135",
  measurementId: "G-QXNV2BGVZ8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export default app;
